export const formatNoun = (number: number) => {
  return number > 1 || number === 0 ? 's' : ''
}
